(function() {
  document.addEventListener("DOMContentLoaded", function () {
    console.log("Kashmir Cart Loaded");

    // Toggles
    const btns = document.querySelectorAll(".ksc__btn-open");
    const addons = document.querySelectorAll(".ksc__addon");
    const closeBtns = document.querySelectorAll(".ksc-close-all");

    function closeAll() {
      addons.forEach(el => el.classList.remove("active"));
    }

    btns.forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const targetId = btn.getAttribute("data-open");
        const target = document.getElementById(targetId);
        
        if (target.classList.contains("active")) {
          closeAll();
        } else {
          closeAll();
          target.classList.add("active");
        }
      });
    });

    closeBtns.forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        closeAll();
      });
    });

    // SHIPPING LOGIC (Simplified ViaCEP)
    const shipBtn = document.querySelector(".ksc-calc-shipping");
    const shipInput = document.getElementById("ksc_zip");
    const shipResult = document.getElementById("ksc_shipping_result");

    if(shipBtn) {
        shipBtn.addEventListener("click", async (e) => {
            e.preventDefault();
            const cep = shipInput.value.replace(/\D/g, "");
            
            if (cep.length !== 8) {
                shipResult.innerHTML = '<span class="error">CEP inválido</span>';
                return;
            }

            // Simple text loading to avoid layout/spinner issues
            const originalBtnText = shipBtn.innerText;
            shipBtn.innerText = "CALCULANDO...";
            shipBtn.disabled = true;
            shipResult.innerHTML = '';
            
            try {
                // 1. Get Address info
                const addrResp = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
                const addrData = await addrResp.json();
                
                if (addrData.erro) throw new Error("CEP não encontrado");

                // 2. Calculate Rates via Shopify AJAX API
                const query = `shipping_address[zip]=${cep}&shipping_address[country]=Brazil&shipping_address[province]=${addrData.uf}`;
                
                const rateResp = await fetch(`/cart/shipping_rates.json?${query}`);
                const rateData = await rateResp.json();

                if (rateData.shipping_rates && rateData.shipping_rates.length > 0) {
                    let html = `<div style="margin-top:10px;text-align:left;">`;
                    html += `<p style="margin-bottom:5px;font-size:12px;color:#888;">Entregas para <b>${addrData.localidade} - ${addrData.uf}</b>:</p>`;
                    
                    rateData.shipping_rates.forEach(rate => {
                        const price = parseFloat(rate.price);
                        const priceStr = price === 0 ? "Grátis" : "R$ " + price.toFixed(2).replace(".", ",");
                        
                        html += `<div style="display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px dashed #eee;font-size:13px;">
                            <span>${rate.presentment_name}</span>
                            <span style="font-weight:bold;">${priceStr}</span>
                        </div>`;
                    });
                    html += `</div>`;
                    shipResult.innerHTML = html;
                } else {
                    shipResult.innerHTML = '<span class="error">Nenhuma entrega encontrada para este CEP.</span>';
                }

            } catch (err) {
                console.error(err);
                shipResult.innerHTML = '<span class="error">Erro ao calcular. Tente novamente.</span>';
            } finally {
                shipBtn.innerText = originalBtnText;
                shipBtn.disabled = false;
            }
        });
    }

    // "Voltar as compras" logic - simulates closing the cart
    const backToShopBtn = document.querySelector(".ksc-back-to-shop-action");
    if(backToShopBtn) {
        backToShopBtn.addEventListener("click", (e) => {
             e.preventDefault();
             // Try to find the theme's close button and click it
             const themeCloseBtn = document.querySelector(".close_pp");
             if(themeCloseBtn) {
                 themeCloseBtn.click();
             } else {
                 // Fallback: simple close if wrapper is known
                 const cartCanvas = document.getElementById("nt_cart_canvas");
                 if(cartCanvas) cartCanvas.classList.add("dn"); // 'dn' is display:none in some themes or we need another trigger
                 document.body.classList.remove("cart-open"); // hypothetical
             }
        });
    }

  });
})();
